<template>
    <div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">区域名称</th>
                <th width="200" style="text-align: left">经营业态</th>
                <th width="100" style="text-align: right" v-if="kindId != null && kindId == 0">数量</th>
                <th width="120" style="text-align: right">含税价(元)</th>
                <th width="120" style="text-align: right">税率(%)</th>
                <th width="120" style="text-align: right">未税价(元)</th>
                <th width="120" style="text-align: right" v-if="kindId != null && kindId == 0">含税小计(元)</th>
                <th v-if="operateContract != 'chakan'" width="80" align="left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="areaPrice, index in areaPriceList">
                <td style="text-align: left">{{areaPrice.bizAreaName}}</td>
                <td style="text-align: left">
                    <div v-if="areaPrice.bizFormNameList != null && areaPrice.bizFormNameList.length > 0" v-for="bizFormName in areaPrice.bizFormNameList">
                        <span class="swb-tags swb-tags-success mr5">{{bizFormName}}</span>
                    </div>
                </td>
                <td style="text-align: right" v-if="kindId != null && kindId == 0">
                    <el-input v-if="operateContract!='chakan'" :maxlength="9" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text" v-model.number="areaPrice.quantity"
                              @change="quantityChange(areaPrice.quantity, index);"></el-input>
                    <span v-if="operateContract =='chakan'">{{areaPrice.quantity}}</span>
                </td>
                <td style="text-align: right">
                    <el-input v-if="operateContract!='chakan'" :maxlength="9" :disabled="(disabled || operateContract=='chakan') && operateContract!='change'" type="text" v-model="areaPrice.price"
                              @change="priceChange(areaPrice.price, index);"></el-input>
                    <span v-if="operateContract =='chakan'">{{areaPrice.price}}</span>
                </td>
                <td style="text-align: right">{{taxRate}}</td>
                <td style="text-align: right">{{areaPrice.ntxPrice}}</td>
                <td style="text-align: right" v-if="kindId != null && kindId == 0">{{areaPrice.amount}}</td>
                <td v-if="operateContract != 'chakan'" align="left"><a class="swb-btn-link" @click="removeAreaPrice(areaPrice.bizAreaId)">移除</a></td>
            </tr>
            <tr class="row">
                <td v-if="operateContract != 'chakan'" :colspan="kindId != null && kindId == 0 ? 8 : 6" class="display-none">
                    <div class="no-data">
                        <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                        <span class="">暂无数据 . . .</span>
                    </div>
                </td>
                <td v-if="operateContract == 'chakan'" :colspan="kindId != null && kindId == 0 ? 7 : 5" class="display-none">
                    <div class="no-data">
                        <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                        <span class="">暂无数据 . . .</span>
                    </div>
                </td>
            </tr>
            </tbody>
            <tfoot class="foot">
            <tr class="row">
                <td :colspan="kindId != null && kindId == 0 ? 8 : 6" v-if="operateContract != 'chakan'">
                    <div class="swb-btn-link" @click="selectBizArea()">
                            <span>
                                <i class="icon iconfont icon-jiahao mr5"></i>选择经营区域
                            </span>
                    </div>
                </td>
                <td :colspan="kindId != null && kindId == 0 ? 7 : 5" v-if="areaPriceList.length <= 0 && operateContract == 'chakan'">
                    <div class="swb-btn-link">
                        <span class="">暂无数据 . . .</span>
                    </div>
                </td>
            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {showRetailerBizAreaSelectDlg} from '../bizArea/dialog'

    import contractApi from '../../api/contract'

    export default {
        name: 'swb-contract-goods-area-price-save',
        desc: '合同商品经营区域价格',
        props: {
            operateContract: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            taxRate: {
                type: Number,
                default: null
            },
            contractGoodsItemId: {
                type: Number,
                default: null
            },
            areaPrices: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            bizFormNameList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            kindId: {
                type: Number
            },
            price: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                //
                areaPriceList: []
            }
        },
        created: function () {
            this.taxRate = Utils.isNoB(this.taxRate) ? 0.00 : parseFloat(this.taxRate).toFixed(2);
            if (!Utils.isNoB(this.contractGoodsItemId) && this.operateContract == 'chakan') {
                this.getAreaPriceList();
            } else {
                let areaPrices = this.areaPrices || [];
                for (let i = 0; i < areaPrices.length; i++) {
                    let areaPrice = areaPrices[i];
                    if (Utils.isNoB(this.taxRate) || Utils.isNoB(areaPrice.price)) {
                        if (!Utils.isNoB(areaPrice.price)) {
                            areaPrice.price = parseFloat(areaPrice.price).toFixed(2);
                        } else if (!Utils.isNoB(this.price)) {
                            areaPrice.price = parseFloat(this.price).toFixed(2);
                        }
                        areaPrice.ntxPrice = areaPrice.price;
                    } else {
                        areaPrice.ntxPrice = (parseFloat(areaPrice.price) / (1 + (parseFloat(this.taxRate) * 0.01))).toFixed(2);
                    }
                    areaPrice.price = Utils.isNoB(areaPrice.price) ? 0.00 : parseFloat(areaPrice.price).toFixed(2);
                    if (!Utils.isNoB(this.kindId) && this.kindId == 0) {
                        if (Utils.isNoB(areaPrice.quantity) || Utils.isNoB(areaPrice.price)) {
                            areaPrice.amount = null;
                        } else {
                            areaPrice.amount = (parseInt(areaPrice.quantity) * parseFloat(areaPrice.price)).toFixed(2);
                        }
                    }
                    //
                    if (!Utils.isNoB(this.bizFormNameList) && this.bizFormNameList.length > 0) {
                        areaPrice.bizFormNameList = this.bizFormNameList;
                    }
                }
                this.areaPriceList = Utils.merge([], areaPrices);
            }
        },
        methods: {
            // 根据合同商品id获取区域价格列表
            getAreaPriceList: function () {
                let self = this;
                //
                let params = {
                    contractGoodsItemId: self.contractGoodsItemId
                };
                let theLoading = MsgBox.loading();
                // 调用查询接口
                contractApi.getContractGoodsAreaPriceListByContractGoodsItemId(params, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let areaPriceList = result.data || [];
                        //
                        for (let i = 0; i < areaPriceList.length; i++) {
                            let item = areaPriceList[i];
                            let bizFormNames = item.bizFormNames;
                            if (!Utils.isNoB(bizFormNames)) {
                                let bizFormNameList = [];
                                if (!Utils.isNoB(bizFormNames)) {
                                    if (bizFormNames.indexOf("|") >= 0) {
                                        bizFormNames = bizFormNames.substring(1, bizFormNames.length - 1);
                                        bizFormNameList = bizFormNames.split("|") || [];
                                    }
                                }
                                item.bizFormNameList = bizFormNameList;
                            }
                            //
                            item.price = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                            item.ntxPrice = Utils.isNoB(item.ntxPrice) ? 0.00 : parseFloat(item.ntxPrice).toFixed(2);
                            item.amount = Utils.isNoB(item.amount) ? 0.00 : parseFloat(item.amount).toFixed(2);
                        }
                        self.areaPriceList = Utils.merge([], areaPriceList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择经营区域
            selectBizArea: function () {
                let self = this;
                let areaPriceList = self.areaPriceList || [];
                let bizAreaIds = areaPriceList.pluck("bizAreaId") || [];
                let parmas = {
                    disabledSelect: true,
                    selectIds: bizAreaIds
                };
                showRetailerBizAreaSelectDlg(parmas, function (bizAreaList, theDlg) {
                    theDlg.close();
                    bizAreaList = bizAreaList || [];
                    for (let i = 0; i < bizAreaList.length; i++) {
                        let bizArea = bizAreaList[i];
                        if (!bizAreaIds.contains(bizArea.id)) {
                            let areaPrice = {
                                bizAreaId: bizArea.id,
                                bizAreaName: bizArea.name,
                                bizFormNameList: self.bizFormNameList,
                                price: parseFloat(Utils.isNoB(self.price) ? 0 : self.price).toFixed(2),
                                ntxPrice: null,
                                amount: null
                            };
                            //
                            if (Utils.isNoB(areaPrice.price) || Utils.isNoB(self.taxRate)) {
                                areaPrice.ntxPrice = null;
                            } else {
                                areaPrice.ntxPrice = (parseFloat(areaPrice.price) / (1 + (parseFloat(self.taxRate) * 0.01))).toFixed(2);
                            }
                            areaPriceList.push(areaPrice);
                        }
                    }
                    self.areaPriceList = Utils.merge([], areaPriceList);
                });
            },
            // 移除经营区域
            removeAreaPrice: function (bizAreaId) {
                let areaPriceList = this.areaPriceList || [];
                for (let i = 0; i < areaPriceList.length; i++) {
                    let item = areaPriceList[i];
                    if (item.bizAreaId == bizAreaId) {
                        areaPriceList.splice(i, 1);
                    }
                }
                this.areaPriceList = Utils.merge([], areaPriceList);
            },
            // 数量变化事件
            quantityChange: function (quantity, index) {
                if (!Utils.isNoB(quantity)) {
                    if (!Utils.isNaturalStr(quantity)) {
                        MsgBox.warning("只能输入大于0的整数！");
                        quantity = null;
                    }
                }
                //
                let areaPriceList = this.areaPriceList || [];
                for (let i = 0; i < areaPriceList.length; i++) {
                    let item = areaPriceList[i];
                    if (i == index) {
                        item.quantity = quantity;
                        if (!Utils.isNoB(this.kindId) && this.kindId == 0) {
                            if (Utils.isNoB(quantity) || Utils.isNoB(item.price)) {
                                item.amount = null;
                            } else {
                                item.amount = (parseInt(quantity) * parseFloat(item.price)).toFixed(2);
                            }
                        }
                    }
                }
                this.areaPriceList = Utils.merge([], areaPriceList);
            },
            // 含税价变化事件
            priceChange: function (price, index) {
                let ntxPrice = null;
                if (Utils.isNoB(this.taxRate) || Utils.isNoB(price)) {
                    ntxPrice = price;
                    if (!Utils.isNoB(price)) {
                        ntxPrice = parseFloat(price).toFixed(2);
                    }
                } else {
                    ntxPrice = (parseFloat(price) / (1 + (parseFloat(this.taxRate) * 0.01))).toFixed(2);
                }
                //
                let areaPriceList = this.areaPriceList || [];
                for (let i = 0; i < areaPriceList.length; i++) {
                    let item = areaPriceList[i];
                    if (i == index) {
                        item.price = Utils.isNoB(price) ? null : parseFloat(price).toFixed(2);
                        item.ntxPrice = ntxPrice;
                        if (!Utils.isNoB(this.kindId) && this.kindId == 0) {
                            if (Utils.isNoB(item.quantity) || Utils.isNoB(item.price)) {
                                item.amount = null;
                            } else {
                                item.amount = (parseInt(item.quantity) * parseFloat(item.price)).toFixed(2);
                            }
                        }
                    }
                }
                this.areaPriceList = Utils.merge([], areaPriceList);
            },
            // 返回数据
            getDlgResult: function () {
                let result = {};
                let selectList = this.areaPriceList || [];
                if (selectList.length <= 0) {
                    result.type = "warn";
                    result.message = "请选择经营区域并设置区域价！";
                } else {
                    let quantityErrMsg = '';
                    let errMsg = '';
                    for (let i = 0; i < selectList.length; i++) {
                        let item = selectList[i];
                        if (Utils.isNoB(item.quantity) && this.kindId != null && this.kindId == 0) {
                            if (Utils.isNoB(errMsg)) {
                                quantityErrMsg = '区域【' + item.bizAreaName + '】';
                            } else {
                                quantityErrMsg += '、【' + item.bizAreaName + '】';
                            }
                        }
                        if (Utils.isNoB(item.price)) {
                            if (Utils.isNoB(errMsg)) {
                                errMsg = '区域【' + item.bizAreaName + '】';
                            } else {
                                errMsg += '、【' + item.bizAreaName + '】';
                            }
                        }
                    }
                    if (!Utils.isNoB(quantityErrMsg)) {
                        result.type = "warn";
                        result.message = errMsg + "请输入具体的数量！";
                    } else if (!Utils.isNoB(errMsg)) {
                        result.type = "warn";
                        result.message = errMsg + "请输入具体的含税价！";
                    } else {
                        result.data = selectList;
                        result.type = "info";
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractGoodsAreaPriceSave.vue